<template>
    <div class="wallet-marquee" v-if="walletConfig?.announcement?.value">
        <marquee>
            {{walletConfig?.announcement?.value}}
        </marquee>
    </div>
</template>

<script>
import marquee from "@/shared/services/marqueeService";
export default {
    name: 'WalletAnnoucement',
    components: {
        marquee
    },
    inject: ['walletConfig'],
}
</script>